import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=a90706c0"
import script from "./TemplateForm.vue?vue&type=script&lang=js"
export * from "./TemplateForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateForm.vue?vue&type=style&index=0&id=a90706c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports